import React, { useEffect, useState } from "react";
import { motion, useScroll } from "framer-motion";
import { MessageCircle, Facebook, Link2, Check, Share2 } from "lucide-react";

export const ShareBar = ({ title, utop = false, className = "" }) => {
  const [copied, setCopied] = useState(false);
  const url = typeof window !== "undefined" ? window.location.href : "";
  const text = encodeURIComponent(`${title} — ${url}`);
  const wa = `https://wa.me/?text=${text}`;
  const fb = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
  const copy = async () => { try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch {} };
  const base = utop
    ? "inline-flex items-center gap-2 rounded-full px-6 py-4 text-lg font-semibold transition hover:-translate-y-0.5 font-utopbody"
    : "inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition hover:-translate-y-0.5";
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="share-bar">
      <span className={`inline-flex items-center gap-2 ${utop ? "text-utop-azul/70 text-lg" : "text-xs tracking-[0.25em] uppercase opacity-70"}`}><Share2 size={utop ? 20 : 14} /> {utop ? "Comparte esta nota" : "Compartir"}</span>
      <a href={wa} target="_blank" rel="noreferrer" data-testid="share-whatsapp" className={`${base} bg-[#25D366] text-white hover:bg-[#1ebe5a]`}><MessageCircle size={utop ? 22 : 16} /> WhatsApp</a>
      <a href={fb} target="_blank" rel="noreferrer" data-testid="share-facebook" className={`${base} bg-[#1877F2] text-white hover:bg-[#166fe0]`}><Facebook size={utop ? 22 : 16} /> Facebook</a>
      <button type="button" onClick={copy} data-testid="share-copy" className={`${base} border-2 ${utop ? "border-utop-azul text-utop-azul hover:bg-utop-azul hover:text-white" : "border-current"}`}>{copied ? <><Check size={16} /> Copiado</> : <><Link2 size={16} /> Copiar enlace</>}</button>
    </div>
  );
};

// Barra de progreso de lectura
export const ReadingProgress = ({ color = "#FFBC01" }) => {
  const { scrollYProgress } = useScroll();
  return <motion.div aria-hidden="true" data-testid="reading-progress" className="fixed top-0 left-0 right-0 h-1.5 z-[45] origin-left" style={{ scaleX: scrollYProgress, background: color }} />;
};

// Botones flotantes de compartir (aparecen al leer)
export const FloatingShare = ({ title, utop = false }) => {
  const [show, setShow] = useState(false);
  useEffect(() => { const f = () => setShow(window.scrollY > 500); f(); window.addEventListener("scroll", f, { passive: true }); return () => window.removeEventListener("scroll", f); }, []);
  if (!show) return null;
  const url = typeof window !== "undefined" ? window.location.href : "";
  const items = [
    ["share-float-whatsapp", `https://wa.me/?text=${encodeURIComponent(`${title} — ${url}`)}`, MessageCircle, "#25D366", "WhatsApp"],
    ["share-float-facebook", `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, Facebook, "#1877F2", "Facebook"],
  ];
  return (
    <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} className="fixed left-4 bottom-28 z-40 hidden md:flex flex-col gap-3" data-testid="share-float">
      {items.map(([id, href, Icon, bg, label]) => (
        <a key={id} href={href} target="_blank" rel="noreferrer" aria-label={`Compartir en ${label}`} data-testid={id} className={`flex items-center justify-center rounded-full text-white shadow-xl hover:scale-110 transition ${utop ? "h-16 w-16" : "h-12 w-12"}`} style={{ background: bg }}><Icon size={utop ? 28 : 20} /></a>
      ))}
    </motion.div>
  );
};
